import {
  ButtonGroup,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { ViewArray } from "@material-ui/icons";
import moment from "moment";

export const behaviorColumns = (onRecordClick) => [
  { path: "name", label: "Name" },
  { path: "description", label: "Description" },
  {
    content: (item) => (
      <Typography aria-label="Status">
        {moment(item.createdAt).format("DD/MM/YYYY")}
      </Typography>
    ),
    label: "Created",
  },
  {
    content: (item) => (
      <ButtonGroup variant="outlined" size="small">
        <Tooltip title="View items">
          <IconButton
            aria-label="View items"
            color="secondary"
            onClick={() => onRecordClick(item, "view")}
          >
            <ViewArray />
          </IconButton>
        </Tooltip>
      </ButtonGroup>
    ),
    label: "Actions",
  },
];
